<div class="mt-4 mb-4">
  <h3 class="text-lg font-semibold text-slate-900">Mandatos</h3>
  <p class="text-sm text-slate-500">
    Mandatos para cobrar bajo demanda a tarjetas que el cliente autorizó.
    @if (!canEdit) { Solo un administrador de Pento puede cambiar esta configuración. }
  </p>
</div>

@if (loading()) {
  <div class="flex justify-center py-6"><i class="pi pi-spin pi-spinner text-2xl text-sky-500"></i></div>
} @else if (loadError()) {
  <p class="text-sm text-red-600">{{ loadError() }}</p>
} @else {
  <div [formGroup]="form" class="flex flex-col gap-5">
    <label class="flex items-center gap-3">
      <p-toggleswitch formControlName="enabled" inputId="mitEnabled" />
      <span class="text-sm font-medium text-slate-800">{{ form.controls.enabled.value ? 'Habilitado' : 'Deshabilitado' }}</span>
    </label>

    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      <div class="flex flex-col gap-1">
        <p-floatlabel variant="on">
          <p-inputNumber inputId="mitCapTx" formControlName="maxAmountPerTransactionCap" mode="currency" currency="MXN" locale="es-MX"
            inputStyleClass="text-right" [minFractionDigits]="2" [maxFractionDigits]="2" fluid />
          <label for="mitCapTx">Tope por cobro</label>
        </p-floatlabel>
        <small class="text-slate-500">Máximo por cobro que puede tener un mandato</small>
      </div>
      <div class="flex flex-col gap-1">
        <p-floatlabel variant="on">
          <p-inputNumber inputId="mitCapMonth" formControlName="maxAmountPerMonthPerMandateCap" mode="currency" currency="MXN" locale="es-MX"
            inputStyleClass="text-right" [minFractionDigits]="2" [maxFractionDigits]="2" fluid />
          <label for="mitCapMonth">Tope mensual por mandato</label>
        </p-floatlabel>
      </div>
      <div class="flex flex-col gap-1">
        <p-floatlabel variant="on">
          <p-inputNumber inputId="mitCapDay" formControlName="maxAmountPerDayCap" mode="currency" currency="MXN" locale="es-MX"
            inputStyleClass="text-right" [minFractionDigits]="2" [maxFractionDigits]="2" fluid />
          <label for="mitCapDay">Tope diario de la compañía</label>
        </p-floatlabel>
        <small class="text-slate-500">Suma de todos los cobros bajo demanda del día</small>
      </div>
      <p-floatlabel variant="on">
        <p-inputNumber inputId="mitRate" formControlName="maxTransactionsPerMinute" [useGrouping]="false" inputStyleClass="text-right" fluid />
        <label for="mitRate">Cobros por minuto</label>
      </p-floatlabel>
      <p-floatlabel variant="on">
        <p-inputNumber inputId="mitValidity" formControlName="maxMandateValidityDays" [useGrouping]="false" suffix=" días"
          inputStyleClass="text-right" fluid />
        <label for="mitValidity">Vigencia máxima del mandato</label>
      </p-floatlabel>
      <p-floatlabel variant="on">
        <p-inputNumber inputId="mitVerificationAmount" formControlName="verificationAmount" mode="currency" currency="MXN" locale="es-MX"
          inputStyleClass="text-right" [minFractionDigits]="2" [maxFractionDigits]="2" fluid />
        <label for="mitVerificationAmount">Cargo de validación (se cancela)</label>
      </p-floatlabel>
      <p-floatlabel variant="on">
        <p-inputNumber inputId="mitTtl" formControlName="enrollmentLinkTtlHours" [useGrouping]="false" suffix=" h"
          inputStyleClass="text-right" fluid />
        <label for="mitTtl">Vigencia de la liga de registro</label>
      </p-floatlabel>
      <div class="flex flex-col gap-1">
        <p-floatlabel variant="on">
          <input pInputText id="mitCardTypes" formControlName="allowedCardTypes" class="w-full" />
          <label for="mitCardTypes">Tipos de tarjeta permitidos</label>
        </p-floatlabel>
        <small class="text-slate-500">Separados por coma (p. ej. CREDIT, DEBIT). Vacío = todos.</small>
      </div>
    </div>
  </div>
}
